import { Card } from './Card'
import Styles from './SkeletonProfileCard.module.scss'
import cx from 'classnames'

export const SkeletonProfileCard = () => (
  <Card
    coverImage={<div className={Styles.placeholder} />}
    profileImage={<div className={cx(Styles.placeholder, Styles.dark)} />}
    className={Styles.icon}
  >
    <div className={cx(Styles.placeholder, Styles.block)} />
    <div className={cx(Styles.placeholder, Styles.block, Styles.large)} />
    <div className={cx(Styles.placeholder, Styles.block, Styles.bottom)} />
  </Card>
)
